import { useState } from "react";
import { Button, Dropdown, type MenuProps } from "antd";
import type { KeyOptionsType } from "../FiltersType";
import { FaChevronDown } from "react-icons/fa";
import type { FiltersHeaderType } from "./types/FiltersHeaderType";
import Icon from "../../Icon";

const FiltersHeader: React.FC<FiltersHeaderType> = ({
    isFilterPanelOpen,
    currentAvailableFilters,
    currentOpenedFilterKeys,
    setCurrentOpenedFilterKeys
}) => {

    const [isOpenFilterList, setIsOpenFilterList] = useState(false);

    const items: MenuProps["items"] = currentAvailableFilters.map(filter => ({
        key: filter.key,
        label: filter.label,
        disabled: currentOpenedFilterKeys.some(f => f === filter.key)
    }))

    const handleClick: MenuProps["onClick"] = (info) => {
        const key = info.key as KeyOptionsType;

        if (currentOpenedFilterKeys.includes(key)) return;

        setCurrentOpenedFilterKeys(prev => [...prev, key]);
        setIsOpenFilterList(false);
    };

    const addFiltersButtonStyle = {
        visibility: !isFilterPanelOpen ? "hidden" : "visible",
        pointerEvents: !isFilterPanelOpen ? "none" : "auto"
    } as const;

    return (
        <div className="filters-base">
            <span>Filters</span>
            <div onClick={(e) => { if (isFilterPanelOpen) e.stopPropagation(); }} >
                <Dropdown
                    overlayStyle={{ zIndex: 900 }}
                    open={isOpenFilterList}
                    menu={{ items, onClick: handleClick }}
                    onOpenChange={setIsOpenFilterList}
                    trigger={["click"]}
                >
                    <Button
                        className="btn-color"
                        style={addFiltersButtonStyle}
                        icon={<Icon icon={FaChevronDown} />}
                    >
                        Add Filter
                    </Button>
                </Dropdown>
            </div>
        </div>
    )
}

export default FiltersHeader;
